import React from 'react'
import {useState, ReactNode} from 'react'
import {Navigate, useLocation} from 'react-router-dom'
import useAuth from '../hooks/useAuth'

type AuthGuardProps = {
  children: ReactNode
}

export default function AuthGuard({children}: AuthGuardProps) {
  const {isAuthenticated, isInitialized} = useAuth()

  const {pathname} = useLocation()

  const [requestedLocation, setRequestedLocation] = useState<string | null>(null)

  if (!isInitialized) {
    return <div>Loading...</div>
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname)
    }
    return <Navigate to={'/'} />
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null)
    return <Navigate to={'/'} />
  }

  return <>{children}</>
}
